import {
  Component,
  inject,
  signal,
  computed,
} from '@angular/core';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  NavigationEnd
} from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs';

import { MenuService } from '@/app/services/common/menu.service';
import { AuthService } from '@/app/auth/auth.service';
import { TypographyComponent } from '../../ui/typography.component';
import { MenuItem } from '@/types/menuItem.interfaces';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    TypographyComponent
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {

  menuService = inject(MenuService);
  auth = inject(AuthService);
  router = inject(Router);
  isExpanded = this.menuService.isSidebarExpanded;

  private expandedMenus = signal<Set<string>>(new Set());

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.syncActiveMenu();
      });

    this.syncActiveMenu();
  }

  isMenuExpanded = (item: MenuItem) =>
    computed(() => this.expandedMenus().has(item.label));

  toggleSidebar(): void {
    this.isExpanded.update(value => !value);
  }

  toggleItem(item: MenuItem): void {
    if (!this.isExpanded()) {
      this.isExpanded.set(true);
    }

    const set = new Set(this.expandedMenus());

    if (set.has(item.label)) {
      set.delete(item.label);
    } else {
      set.add(item.label);
    }

    this.expandedMenus.set(set);
  }

  private syncActiveMenu(): void {
    const menus = this.menuService.roleMenu();
    const currentUrl = this.router.url.split('?')[0];

    const newExpanded = new Set<string>(this.expandedMenus());

    menus.forEach((item) => {
      if (item.children?.some(child => currentUrl.includes(child.url))) {
        newExpanded.add(item.label);
      }
    });

    this.expandedMenus.set(newExpanded);
  }

  isChildActive(item: MenuItem): boolean {
    if (!item.children) return false;

    const currentUrl = this.router.url.split('?')[0];

    return item.children.some(child =>
      currentUrl.includes(child.url)
    );
  }

  logout(): void {
    this.auth.logout();
  }
}
